import { render, staticRenderFns } from "./eventItemsComponent.vue?vue&type=template&id=42d4a846&"
import script from "./eventItemsComponent.vue?vue&type=script&lang=ts&"
export * from "./eventItemsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports